import styled from 'styled-components'
import { ANATOMY_V2_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const AnatomyV2BodyPartsStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
    padding: 16px;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0 16px;
  `,

  Grid: styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    margin-top: auto;
  `,

  OptionCard: styled.button<{ $isSelected: boolean }>`
    position: relative;
    background: ${COLORS.WHITE};
    border: none;
    border-radius: 14px;
    overflow: hidden;
    cursor: pointer;
    padding: 10px 10px 6px;
    text-align: center;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${COLORS.WHITE};
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 14px;
      border: 2px solid ${ANATOMY_V2_ACCENT_COLOR};
      opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0)};
      transition: opacity 0.15s;
      pointer-events: none;
    }
  `,

  CardImage: styled.div`
    width: 100%;

    img {
      width: 100%;
      height: 72px;
      display: block;
      object-fit: cover;
    }
  `,

  CardLabel: styled.p`
    margin-top: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    color: ${COLORS.BLACK};
  `,

  StyledButton: styled(Button)`
    width: 100%;
    margin-top: 16px;
  `,
}
